
































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IProduct } from '@/api/types-client'
import { sortByNumber, sortByString } from '@/utils/sort'

@Component({
  name: 'ProductsTable'
})
export default class extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => {
      return []
    }
  })
  list!: Array<IProduct>;

  @Prop({ type: Boolean }) private _listLoading = false;

  get listLoading() {
    return this._listLoading
  }

  set listLoading(value) {
    this._listLoading = value
  }

  get isLoading(): boolean {
    return this._listLoading === true
  }

  sortId(a: IProduct, b: IProduct): number { return sortByNumber(a.productId, b.productId) }
  sortName(a: IProduct, b: IProduct): number { return sortByString(a.name, b.name) }
  sortOrderType(a: IProduct, b: IProduct): number { return sortByString(this.getTypeName(a), this.getTypeName(b)) }
  getTypeName(t: IProduct): string { return t.orderType == null ? '' : t.orderType.name }

  handleAdd() {
    this.$emit('add')
  }

  handleEdit(row: IProduct) {
    this.$emit('edit', row.productId)
  }

  handleClose() {
    this.$emit('close')
  }

  handleDelete(productId: number) {
    this.$confirm('Confirm to deactivate this Product?', 'Warning', {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      type: 'warning'
    })
      .then(async() => {
        this.$emit('delete', productId)
      })
      .catch(err => { console.error(err) })
  }
}
